module.exports = __webpack_public_path__ + "img/courses.91daaa1b.png";